import { FilterMatchMode } from "primereact/api";

export class NombrePep {
    model = {
        id: { value: null, export: false, header: 'Código', table: true, isNumeric: true, filter: true, matchMode: FilterMatchMode.EQUALS, headerStyle: { width: '9%', minWidth: '9rem' } },
        nombres: {
            value: '', export: true, header: 'Nombres', required: 'Campo requerido', table: true, filter: true, sort: true,
            maxLength: 'Máximo 500 caracteres', minLength: 'Mínimo 4 caracteres', max: 500, min: 4,
            filterPlaceholder: 'Buscar Nombres', filterField: 'nombres', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '25%', minWidth: '15rem' }
        },
        identificacion: {
            value: '', export: true, header: 'Identificación', required: false, table: false, filter: false,
            maxLength: 'Máximo 50 caracteres', minLength: 'Mínimo 10 caracteres', max: 50, min: 4,
        },
        puesto: {
            value: '', export: true, header: 'Puesto institucional', required: true, table: true, filter: true, sort: true,
            maxLength: 'Máximo 300 caracteres', minLength: 'Mínimo 4 caracteres', max: 300, min: 4,
            filterField: 'puesto', filterPlaceholder: 'Buscar por puesto institucional', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '25%', minWidth: '15rem' }
        },
        institucion: {
            value: null, export: true, header: 'Institución', required: 'Institución es requerido', table: true, sort: false, filter: true,
            filterField: 'institucion', filterPlaceholder: 'Buscar por institución', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '35%', minWidth: '22rem' }
        },
        rmu_anual: {
            value: null, export: false, header: 'Remuneración anual', required: false, table: false
        },
        rmu_mensual: {
            value: null, export: false, header: 'Remuneración mensual', required: false, table: false
        },
        estado: {
            value: null, export: true, header: 'Estado', required: 'Estado es requerido', table: true, sort: false, style: { minWidth: '7rem', width: '7rem' }
        },
        tipo: {
            value: null, export: false, header: 'Tipo de identificación', required: false, table: false, sort: false
        },
    }
    optionLabel = 'nombre';
}
